import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { marketingApi, MKT_QK, showNum, useMarketingEnabled } from "./api";

/**
 * MKT-1 · 首页「内容营销 · 本周」卡（订阅版首页经营助手 · 样稿画面 ① 右下）。
 * 与内容营销页概览同一个接口（GET /api/v1/marketing/overview?window=7d）——三个数：发帖（S4）/ 带来访问 / 带来订单（本系统按 src=s4）。
 * 没开通 / 企业版：不渲染（返回 null，不占位）。S4 拿不到发帖数 = 「未知」，不显示 0。
 */
export function HomeSocialCard() {
  const enabled = useMarketingEnabled();
  const q = useQuery({ queryKey: MKT_QK.overview("7d"), queryFn: () => marketingApi.overview("7d"), enabled, refetchInterval: 300_000 });
  if (!enabled) return null;
  const d = q.data;
  return (
    <div className="rounded-md border border-slate-200 bg-white p-3" data-testid="home-social-card">
      <div className="flex items-center gap-2">
        <b className="text-slate-900">内容营销 · 本周</b>
        <span className="flex-1" />
        <Link to="/marketing" className="text-[13px] text-brand hover:underline">进入内容营销 ›</Link>
      </div>
      {q.isError ? (
        <div className="mt-3 text-[12px] text-rose-600">内容营销数据加载失败</div>
      ) : (
        <div className="mt-2.5 grid grid-cols-3 gap-2">
          <div className="rounded-md bg-slate-50 px-3 py-2"><span className="block text-[12px] text-slate-400">发帖</span><b className="text-[20px] text-slate-900" data-testid="home-social-posts">{d ? showNum(d.posts_published) : "…"}</b></div>
          <div className="rounded-md bg-slate-50 px-3 py-2"><span className="block text-[12px] text-slate-400">带来访问</span><b className="text-[20px] text-slate-900" data-testid="home-social-visits">{d ? d.visits : "…"}</b></div>
          <div className="rounded-md bg-slate-50 px-3 py-2"><span className="block text-[12px] text-slate-400">带来订单</span><b className="text-[20px] text-accent" data-testid="home-social-orders">{d ? d.orders : "…"}</b></div>
        </div>
      )}
      <div className="mt-2 text-[11.5px] text-slate-400">发帖数来自 S4 · 访问 / 订单由本系统按 src=s4 统计</div>
    </div>
  );
}
